import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

export default function Terms() {
  return (
    <div className="min-h-screen">
      <Navbar />

      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">Terms and Conditions</h1>
          <p className="text-dark-400 mb-8">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>

          <div className="prose prose-invert max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">1. Agreement to Terms</h2>
              <p className="text-dark-300 leading-relaxed">
                By accessing or using the GINGERBREAD!PRIVACY platform (the "Service"), operated by Monadnock Cyber LLC ("Company," "we," "us," or "our"),
                you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our Service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">2. Description of Service</h2>
              <p className="text-dark-300 leading-relaxed mb-4">
                GINGERBREAD!PRIVACY provides privacy risk assessment and intelligence services, including:
              </p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Data breach exposure scanning</li>
                <li>Data broker exposure identification</li>
                <li>Direct opt-out links to remove personal data from brokers</li>
                <li>Privacy risk scoring and recommendations</li>
                <li>PDF reports summarizing findings</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">3. Account Registration</h2>
              <p className="text-dark-300 leading-relaxed mb-4">To use our Service, you must:</p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Be at least 18 years of age</li>
                <li>Provide accurate and complete registration information</li>
                <li>Maintain the security of your account credentials</li>
                <li>Enable two-factor authentication (mandatory)</li>
                <li>Notify us immediately of any unauthorized account use</li>
              </ul>
              <p className="text-dark-300 leading-relaxed mt-4">
                You are responsible for all activities that occur under your account.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">4. Authorized Use</h2>
              <p className="text-dark-300 leading-relaxed mb-4">
                You may only use our Service to conduct privacy assessments on:
              </p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Yourself</li>
                <li>Individuals who have given you explicit written consent</li>
                <li>Minor children for whom you are the legal guardian</li>
                <li>Employees or executives, with proper corporate authorization</li>
              </ul>
              <p className="text-dark-300 leading-relaxed mt-4">
                <strong>Prohibited:</strong> You may not use our Service to conduct assessments on individuals without their knowledge or consent,
                for stalking, harassment, or any illegal purpose.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">5. Payment Terms</h2>
              <p className="text-dark-300 leading-relaxed mb-4">
                Paid services are billed as described at the time of purchase. All payments are processed securely through Stripe.
              </p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Prices are in US dollars unless otherwise stated</li>
                <li>All sales are final; refunds are at our sole discretion</li>
                <li>We reserve the right to modify pricing with notice</li>
                <li>Subscription services (Inner Circle) may be cancelled at any time</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">6. Intellectual Property</h2>
              <p className="text-dark-300 leading-relaxed">
                The Service, including its design, features, content, and reports, is owned by Monadnock Cyber LLC and protected by
                intellectual property laws. "GINGERBREAD!PRIVACY" is a trademark of Monadnock Cyber LLC. You may not copy, modify, distribute,
                or reverse engineer any part of our Service without written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">7. Disclaimer of Warranties</h2>
              <p className="text-dark-300 leading-relaxed mb-4">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO:
              </p>
              <ul className="list-disc list-inside text-dark-300 space-y-2 ml-4">
                <li>Completeness or accuracy of data broker or breach information</li>
                <li>Success of opt-out requests (third-party broker compliance is beyond our control)</li>
                <li>Fitness for a particular purpose</li>
                <li>Non-infringement</li>
              </ul>
              <p className="text-dark-300 leading-relaxed mt-4">
                Our assessments are based on publicly available information and third-party data sources. We cannot guarantee
                the discovery of all data exposures or the complete removal of your information from data brokers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">8. Limitation of Liability</h2>
              <p className="text-dark-300 leading-relaxed">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, MONADNOCK CYBER LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY,
                OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF THE SERVICE.
              </p>
              <p className="text-dark-300 leading-relaxed mt-4">
                Our total liability for any claims arising from the Service shall not exceed the amount you paid us in the 12 months
                preceding the claim.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">9. Indemnification</h2>
              <p className="text-dark-300 leading-relaxed">
                You agree to indemnify, defend, and hold harmless Monadnock Cyber LLC and its officers, directors, employees, and agents
                from any claims, damages, losses, or expenses (including reasonable attorneys' fees) arising from your use of the Service
                or violation of these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">10. Termination</h2>
              <p className="text-dark-300 leading-relaxed">
                We may suspend or terminate your account at any time for violation of these Terms or for any other reason at our sole discretion.
                Upon termination, your right to use the Service will immediately cease, and we may delete your account data in accordance with
                our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">11. Governing Law</h2>
              <p className="text-dark-300 leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the State of New Hampshire,
                without regard to its conflict of law provisions. Any disputes arising from these Terms or the Service shall be
                resolved in the state or federal courts located in New Hampshire.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">12. Changes to Terms</h2>
              <p className="text-dark-300 leading-relaxed">
                We reserve the right to modify these Terms at any time. We will notify you of material changes by email or
                through a prominent notice on our website. Continued use of the Service after such changes constitutes acceptance
                of the new Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">13. Severability</h2>
              <p className="text-dark-300 leading-relaxed">
                If any provision of these Terms is found to be unenforceable, the remaining provisions will continue in full force and effect.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">14. Contact Information</h2>
              <p className="text-dark-300 leading-relaxed">
                For questions about these Terms, please contact us:
              </p>
              <div className="mt-4 text-dark-300">
                <p><strong>Monadnock Cyber LLC</strong></p>
                <p>Email: <a href="mailto:privacy@monadnockcyber.com" className="text-ginger-500 hover:underline">privacy@monadnockcyber.com</a></p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}
